import { sx } from '../../../lib/sx'
import type { Vals } from '../../../demo/vals'

export function JoinInvite({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding:64px 20px 34px;display:flex;flex-direction:column;overflow:auto")}>
      <img src="/assets/logo-nordvpn-dark.svg" alt="NordVPN" style={sx("height:16px;width:auto;align-self:flex-start;margin-bottom:20px")} />
      <span style={sx("font-size:var(--fs-5xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm);line-height:34px;margin-bottom:6px")}>
        {v.managerEmailAddress}
        {' invited you to their group'}
      </span>
      <span style={sx("font-size:var(--fs-sm);line-height:20px;color:var(--text-secondary);margin-bottom:20px")}>
        You get your own NordVPN account, paid for by them. Nothing else is shared unless you say so.
      </span>
      <div style={sx("display:flex;flex-direction:column;gap:10px;margin-bottom:16px")}>
        <div style={sx("padding:14px 16px;border-radius:var(--radius-md);background:var(--bg-secondary);border:1px solid var(--border-secondary);display:flex;gap:12px;align-items:center")}>
          <span style={sx("width:20px;height:20px;flex:none;background:var(--text-success);-webkit-mask:url(/assets/icons/checkmark.svg) center/contain no-repeat;mask:url(/assets/icons/checkmark.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-sm);line-height:20px")}>
            Your own login, your own 10 devices
          </span>
        </div>
        <div style={sx("padding:14px 16px;border-radius:var(--radius-md);background:var(--bg-secondary);border:1px solid var(--border-secondary);display:flex;gap:12px;align-items:center")}>
          <span style={sx("width:20px;height:20px;flex:none;background:var(--text-success);-webkit-mask:url(/assets/icons/checkmark.svg) center/contain no-repeat;mask:url(/assets/icons/checkmark.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-sm);line-height:20px")}>
            VPN and Threat Protection Pro included
          </span>
        </div>
        <div style={sx("padding:14px 16px;border-radius:var(--radius-md);background:var(--bg-secondary);border:1px solid var(--border-secondary);display:flex;gap:12px;align-items:center")}>
          <span style={sx("width:20px;height:20px;flex:none;background:var(--text-secondary);-webkit-mask:url(/assets/icons/lock.svg) center/contain no-repeat;mask:url(/assets/icons/lock.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-sm);line-height:20px")}>
            They can't see what you browse — ever
          </span>
        </div>
      </div>
      <div style={sx("padding:14px 16px;border-radius:var(--radius-md);background:var(--bg-tertiary);display:flex;gap:12px;align-items:flex-start;margin-bottom:16px")}>
        <span style={sx("width:18px;height:18px;flex:none;margin-top:1px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/info.svg) center/contain no-repeat;mask:url(/assets/icons/info.svg) center/contain no-repeat")} />
        <span style={sx("font-size:var(--fs-xs);line-height:18px;color:var(--text-secondary)")}>
          Joining shares nothing about your activity. If they later ask this phone to send security alerts, you'll get to decide then.
        </span>
      </div>
      <div style={sx("margin-top:auto;display:flex;flex-direction:column;gap:8px")}>
        <button onClick={v.acceptInvite} style={sx("height:52px;border-radius:var(--radius-full);border:none;background:var(--bg-accent);color:#fff;font-family:inherit;font-size:var(--fs-md);font-weight:var(--fw-medium);cursor:pointer")}>
          Join the group
        </button>
        <button onClick={v.declineInvite} style={sx("height:44px;border-radius:var(--radius-full);border:none;background:transparent;color:var(--text-secondary);font-family:inherit;font-size:var(--fs-sm);cursor:pointer")}>
          Not now
        </button>
      </div>
    </div>
  )
}
